import { useRequest } from 'liyu-pc-base/init-plugin';

export async function query_person_detail_list(params?: {
  [key: string]: any;
}): Promise<RoleResponse> {
  return useRequest().post('/sys/query_person_detail_list', params);
}

export async function create_organization_by_role_template(params: Record<string, any>) {
  return useRequest().post('/org/create_organization_by_role_template', params);
}

export async function removePerson(params: Record<string, any>) {
  return useRequest().post('/sys/delete_user', params);
}
export async function recoverPerson(params: Record<string, any>) {
  return useRequest().post('/sys/recover_user', params);
}
export async function resetPassword(params: Record<string, any>) {
  return useRequest().post('/sys/reset_password', params);
}
export async function create_role_list_and_person(params: Record<string, any>) {
  return useRequest().post('/org/create_role_list_and_person', params);
}
export async function query_role_id_list(params: Record<string, any>) {
  return useRequest().post('/org/query_role_id_list', params);
}
export async function query_role_list(params: Record<string, any>) {
  return useRequest().post('/production_event/query_role_list', params);
}
export async function create_shift_and_user(params: Record<string, any>) {
  return useRequest().post('/shift/create_shift_and_user', params);
}
export async function check_shift_and_user(params: Record<string, any>) {
  return useRequest().post('/shift/check_shift_and_user', params);
}

export async function addPerson(params: Record<string, any>) {
  return useRequest().post('/sys/create_user', params);
  // return request('/sys.create_user', {
  //   method: 'POST',
  //   data: {
  //     ...params,
  //     method: 'post',
  //   },
  // });
}

export async function updatePerson(params: Record<string, any>) {
  return useRequest().post('/sys/update_user', params);
}

interface RuleItem {
  key: string | number;
  callNo: number;
  avatar: string;
  desc: string;
  disabled: false;
  href: string;
  name: string;
  owner: string;
  progress: number;
  status: number;
  updatedAt: string;
  createdAt: string;
}

interface RoleResponse {
  current: number;
  data: RuleItem[];
  pageSize: string;
  success: boolean;
  total: number;
}
